import { MutableRefObject } from 'react';

export const setInstanceToRef = (
  ref: MutableRefObject<unknown>,
  { component }: { [key: string]: any }
) => {
  // eslint-disable-next-line no-param-reassign
  ref.current = component.instance();
};
